<template>
  <Toast />
  <ConfirmDialog />
  <ul class="clase-breadcrumb">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Reportes</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">Ventas</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <span class="titulo-new"> REPORTE GENERAL DE VENTAS</span>
    </div>
    <div class="col-12">
      <div class="p-fondo">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-2">
            <span><strong>SUCURSAL: </strong></span>
            <Dropdown v-model="sucursalSelected" :options="sucursales" optionLabel="nombre" optionValue="id">
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>CÓDIGO VENTA: </strong></span>
            <InputNumber
              v-model="codigoVenta"
              placeholder="Código Venta"
              :inputClass="'text-right'"
              :min="0"
              :useGrouping="false"
              @keyup.enter="BuscarFiltro"
            />
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>CÓDIGO CAJA: </strong></span>
            <InputNumber
              v-model="codigoCaja"
              placeholder="Código Caja"
              :inputClass="'text-right'"
              :min="0"
              :useGrouping="false"
              @keyup.enter="BuscarFiltro"
            />
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>PACIENTE: </strong></span>
            <AutoComplete
              :dropdown="true"
              field="nombre"
              v-model="clienteSelected"
              :suggestions="clientesListadoFiltrado"
              @complete="buscarCliente($event)"
              placeholder="Buscar Cliente"
            />
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>MÉDICO: </strong></span>
            <Dropdown
              v-model="medicoSelected"
              :options="medicos"
              optionLabel="nombre_completo"
              optionValue="id"
              :filter="true"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>USUARIO VENTAS: </strong></span>
            <Dropdown v-model="userSeleccionado" :options="users" optionLabel="name" optionValue="id"> </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>ESTADO VENTA: </strong></span>
            <Dropdown v-model="estadoSelected" :options="estados" optionLabel="nombre" optionValue="id"> </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>FECHA INCIO: </strong></span>
            <InputText type="date" v-model="fecha_inicio" dateFormat="dd/mm/yy" />
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>FECHA FIN: </strong></span>
            <InputText type="date" v-model="fecha_fin" dateFormat="dd/mm/yy" />
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>M. DE PAGO: </strong></span>
            <Dropdown v-model="metodoPagoSelected" :options="metodo_pagos" optionLabel="nombre" optionValue="id">
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>ACCIONES: </strong></span>
            <Button
              label="BUSCAR"
              icon="pi pi-search"
              class="p-button-info"
              v-tooltip.top="'Buscar'"
              :loading="enviando"
              :disabled="enviando"
              @click="BuscarFiltro"
            />
          </div>
        </div>
      </div>
      <div class="mt-4 card style_card" v-if="ventas.length > 0">
        <div class="p-fluid formgrid grid">
          <table class="table table-bordered table-striped" style="width: 100%">
            <tr>
              <th class="text-center">
                TOTAL VENTAS:
                <span class="p-badge p-badge-blue p-mr-2" style="font-size: 1rem">
                  {{ convertirNumeroGermanicFormat(totalesGenerales.total_venta + totalesGenerales.total_descuento) }}
                  Bs.
                </span>
              </th>
              <th class="text-center">
                VENTAS CRÉDITO:
                <span class="p-badge p-badge-danger p-mr-2" style="font-size: 1rem">
                  {{ convertirNumeroGermanicFormat(totalesGenerales.total_credito) }}
                  Bs.
                </span>
              </th>
              <th class="text-center">
                TOTAL DESCUENTOS:
                <span class="p-badge p-badge-danger p-mr-2" style="font-size: 1rem">
                  {{ convertirNumeroGermanicFormat(totalesGenerales.total_descuento) }}
                  Bs.
                </span>
              </th>
              <th class="text-center">
                TOTAL GENERAL:
                <span class="p-badge p-badge-success p-mr-2" style="font-size: 1rem">
                  {{ convertirNumeroGermanicFormat(totalesGenerales.total_venta - totalesGenerales.total_credito) }}
                  Bs.
                </span>
              </th>
            </tr>
          </table>
        </div>

        <!-- Indicador de página actual -->
        <div class="mt-2 text-center text-sm text-secondary">
          <i class="pi pi-info-circle mr-2"></i>
          Los totales son del filtro completo ({{ totalRegistros }} registros). Mostrando página {{ paginaActual }} de
          {{ Math.ceil(totalRegistros / porPagina) }}
        </div>
      </div>
      <div class="mt-4">
        <DataTable
          ref="reporte_ventas"
          key="id"
          :value="ventas"
          :lazy="true"
          :paginator="true"
          :rows="porPagina"
          :totalRecords="totalRegistros"
          :loading="enviando"
          @page="onPageChange"
          :rowsPerPageOptions="[25, 50, 100, 200]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
          responsiveLayout="scroll"
          class="p-datatable-sm"
          :filters="buscar"
          stripedRows
          showGridlines
          v-model:expandedRows="expandedRows"
        >
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
              <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
                <i class="pi pi-search" />
                <InputText v-model="buscar['global'].value" placeholder="Buscar..." />
              </span>

              <span class="block mt-2 md:mt-0 p-input-icon-left" v-if="'R_Ventas de Ventas' in auth.user.permissions">
                <Button text icon="pi pi-minus" label="Contraer Todo" @click="collapseAll" class="mr-2" />
              </span>

              <span class="block mt-2 md:mt-0 p-input-icon-left" v-if="'R_Ventas de Ventas' in auth.user.permissions">
                <Button text icon="pi pi-plus" label="Expandir Todo" @click="expandAll" class="mr-2" />
              </span>

              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <Button
                  v-if="'R_Ventas DescargarPDF' in auth.user.permissions"
                  label="PDF Imprimir"
                  icon="pi pi-file-pdf"
                  class="p-button-outlined p-button-danger mr-2"
                  v-tooltip.top="'Imprimir Reporte PDF'"
                  :loading="generandoPDF"
                  :disabled="generandoPDF || ventas.length === 0"
                  @click="generarPDF"
                />
              </span>

              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <Button
                  v-if="'R_Ventas DescargarEXCEL' in auth.user.permissions"
                  label="EXCEL Exportar"
                  icon="pi pi-file-excel"
                  class="p-button-outlined p-button-success"
                  v-tooltip.top="'Imprimir Reporte Excel'"
                  :loading="exportando"
                  :disabled="exportando || ventas.length === 0"
                  @click="exportVentas"
                />
              </span>
            </div>
          </template>

          <template #loading>
            <div class="flex align-items-center justify-content-center p-4">
              <ProgressSpinner />
              <span class="ml-3">Cargando ventas...</span>
            </div>
          </template>

          <template #empty>
            <div class="text-center p-4">
              <i class="pi pi-info-circle" style="font-size: 2rem; color: #64748b"></i>
              <p class="mt-2 text-secondary">Debe aplicar filtros para ver resultados en la tabla!</p>
            </div>
          </template>

          <Column expander style="width: 1rem" v-if="'R_Ventas de Ventas' in auth.user.permissions"></Column>

          <Column class="text-right" field="id" header="CÓD" style="width: 1rem"></Column>

          <Column field="usuario" header="USUARIO" :sortable="true"></Column>

          <Column field="fecha_venta" header="F.VENTA" style="width: 70px">
            <template #body="{ data }">
              {{ formatDateTime(data.fecha_venta) }}
            </template>
          </Column>

          <Column field="nombre_cliente" header="CLIENTE" style="font-weight: bold"></Column>

          <Column field="nit" header="CI/NIT"></Column>

          <Column field="descuento" header="DESC." class="text-right" style="width: 20px">
            <template #body="{ data }">
              {{ convertirNumeroGermanicFormat(data.descuento) }}
            </template>
          </Column>

          <Column field="efectivo" header="EFECTIVO" class="text-right" style="width: 20px; font-weight: bold">
            <template #body="{ data }">
              <span v-tooltip.top="'Efectivo'">
                {{ convertirNumeroGermanicFormat(data.efectivo) }}
              </span>
            </template>
          </Column>

          <Column field="transferencias" header="TRANSF." class="text-right" style="width: 20px; font-weight: bold">
            <template #body="{ data }">
              <span v-tooltip.top="'Transferencias/Qr'">
                {{ convertirNumeroGermanicFormat(data.transferencias) }}
              </span>
            </template>
          </Column>

          <Column field="total_cancelar" header="T.VENTA" class="text-right" style="width: 20px; font-weight: bold">
            <template #body="{ data }">
              {{ convertirNumeroGermanicFormat(data.total_cancelar) }}
            </template>
          </Column>

          <Column field="facturado" header="ENVIADO" class="text-center" v-if="ocultarFacturado">
            <template #body="{ data }">
              <span
                class="product-badge status"
                :class="{
                  'status-outofstock': data.facturado === 0,
                  'status-instock': data.facturado === 1
                }"
              >
                {{ textoFacturado(data.facturado) }}
              </span>
            </template>
          </Column>

          <Column field="nombre_medico" header="MÉDICO" v-if="ocultarMedico">
            <template #body="{ data }">
              {{ data.nombre_medico ?? 'SIN MÉDICO' }}
            </template>
          </Column>

          <Column field="nombre_paquete" header="PAQUETE" v-if="ocultarPaquete">
            <template #body="{ data }">
              {{ data.nombre_paquete ?? 'SIN PAQUETE' }}
            </template>
          </Column>

          <Column field="estado" header="ESTADO">
            <template #body="{ data }">
              <span
                class="product-badge status"
                :class="{
                  'status-outofstock': data.estado === 0,
                  'status-instock': data.estado === 1
                }"
              >
                {{ textoEstado(data.estado) }}
              </span>
            </template>
          </Column>

          <Column field="entregado" header="ENTREGADO" class="text-center" v-if="marcar_entregado">
            <template #body="{ data }">
              <span
                class="product-badge status"
                :class="{
                  'status-no-entragado': data.entregado === 0,
                  'status-en-proceso': data.entregado === 1,
                  'status-entregado': data.entregado === 2
                }"
              >
                {{ textoEstadoEntregado(data.entregado) }}
              </span>
            </template>
          </Column>

          <ColumnGroup type="footer">
            <Row>
              <Column footer="TOTALES:" class="text-right" :colspan="7" />
              <Column class="text-right" :footer="convertirNumeroGermanicFormat(total_efectivo)" />
              <Column class="text-right" :footer="convertirNumeroGermanicFormat(total_transferencia)" />
            </Row>
          </ColumnGroup>

          <Column>
            <template #header>
              <i class="pi pi-cog text-xl ml-2" />
            </template>
            <template #body="slotProps">
              <Button
                class="p-button-rounded p-button-primary p-button-sm"
                v-tooltip.top="'Ver Acciones'"
                icon="pi pi-ellipsis-v"
                @click="$refs['menu' + slotProps.data.id].toggle($event)"
              />
              <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)" />
            </template>
          </Column>

          <template #expansion="slotProps" v-if="'R_Ventas de Ventas' in auth.user.permissions">
            <div style="background-color: #ffffff" class="p-3">
              <h5>
                <span style="border-bottom: 1px solid #ccc">
                  DETALLE DE VENTA:
                  <strong>{{ slotProps.data.id }} - {{ slotProps.data.razon_social }}</strong>
                </span>
              </h5>

              <div v-if="!slotProps.data.productos" class="text-center p-4">
                <ProgressSpinner style="width: 30px; height: 30px" />
                <p class="mt-2">Cargando productos...</p>
              </div>

              <DataTable
                v-else
                :value="slotProps.data.productos"
                class="p-datatable-sm"
                responsiveLayout="scroll"
                stripedRows
                showGridlines
                style="
                  border: 1px solid #000000;
                  border-radius: 2px;
                  padding: 2px;
                  box-shadow: 0px 0px 1px 0px #000000;
                  font-size: 12px;
                "
              >
                <Column field="id" header="COD_PROD" class="text-right"></Column>
                <Column
                  field="descripcion"
                  header="PRODUCTO/DESCRIPCIÓN"
                  style="width: 300px; font-weight: bold"
                ></Column>
                <Column header="CANTIDAD" class="text-right">
                  <template #body="slotProps">
                    {{ slotProps.data.cantidad }}
                  </template>
                </Column>
                <Column header="PRECIO" class="text-right">
                  <template #body="slotProps">
                    {{ convertirNumeroGermanicFormat(slotProps.data.precio) }}
                  </template>
                </Column>
                <Column header="SUBTOTAL" class="text-right">
                  <template #body="slotProps">
                    {{ convertirNumeroGermanicFormat(slotProps.data.cantidad * slotProps.data.precio) }}
                  </template>
                </Column>
                <Column header="DESCUENTO" class="text-right">
                  <template #body="slotProps">
                    {{ convertirNumeroGermanicFormat(slotProps.data.descuento_neto) }}
                  </template>
                </Column>
                <Column header="TOTAL" class="text-right">
                  <template #body="slotProps">
                    {{
                      convertirNumeroGermanicFormat(
                        slotProps.data.cantidad * slotProps.data.precio - slotProps.data.descuento_neto
                      )
                    }}
                  </template>
                </Column>
              </DataTable>
            </div>
          </template>
        </DataTable>
        <VentaFacturar
          :show="ventafacturaDialog"
          :ventaFactura="ventaFactura"
          @closeModal="ocultarDialog"
          @actualizarListado="BuscarFiltro"
        >
        </VentaFacturar>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import VentaService from '@/service/VentaService'
import SucursalService from '@/service/SucursalService'
import UserService from '@/service/UserService'
import ClienteService from '@/service/ClienteService'
import { useAuth } from '@/stores'
import MedicoService from '@/service/MedicoService'
import PaqueteProductoService from '@/service/PaqueteProductoService'
import VentaFacturar from '@/module/ventas/VentaFacturar.vue'
import MetodoPagoService from '@/service/MetodoPagoService.js'

export default {
  components: { VentaFacturar },
  data() {
    return {
      fecha_inicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      fecha_fin: new Date().toISOString().substr(0, 10),
      enviando: false,
      ventas: [],
      sucursalSelected: 0,
      sucursales: [{ id: 0, nombre: 'TODAS' }],
      userSeleccionado: 0,
      users: [{ id: 0, name: 'TODOS' }],
      medicoSelected: 0,
      medicos: [{ id: 0, nombre_completo: 'TODOS' }],
      paqueteSelected: 0,
      paquetes: [{ id: 0, nombre: 'TODOS' }],
      generandoPDF: false,
      exportando: false,
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        }
      },
      clienteSelected: null,
      clientesListadoFiltrado: [],
      estadoSelected: 2,
      estados: [
        { id: 2, nombre: 'TODOS' },
        { id: 1, nombre: 'VALIDA' },
        { id: 0, nombre: 'ANULADA' }
      ],
      codigoVenta: null,
      codigoCaja: null,
      ventaFactura: {},
      ventafacturaDialog: false,
      expandedRows: [],
      metodo_pagos: [],
      metodoPagoSelected: 0,
      ventas_a_creditos: 0,

      // Paginación
      paginaActual: 1,
      porPagina: 50,
      totalRegistros: 0,

      // Totales del servidor
      totalesGenerales: {
        total_venta: 0,
        total_descuento: 0,
        total_efectivo: 0,
        total_transferencia: 0,
        total_credito: 0
      },

      // Columnas dinámicas (recuperadas de versión anterior)
      ocultarFacturado: false,
      ocultarMedico: false,
      ocultarPaquete: false,

      // Marcar entregado (recuperado de versión anterior)
      marcar_entregado: false,
      parametros_sistema: {}
    }
  },
  ventaService: null,
  sucursalService: null,
  userService: null,
  clienteService: null,
  auth: null,
  medicoService: null,
  paqueteProductoService: null,
  metodoPagoService: null,

  computed: {
    totalVenta() {
      return this.ventas.filter((v) => v.estado == 1).reduce((sum, v) => sum + parseFloat(v.total_cancelar), 0)
    },
    totalDescuento() {
      return this.ventas.filter((v) => v.estado == 1).reduce((sum, v) => sum + parseFloat(v.descuento), 0)
    },
    total_efectivo() {
      return this.ventas.filter((v) => v.estado == 1).reduce((sum, v) => sum + parseFloat(v.efectivo || 0), 0)
    },
    total_transferencia() {
      return this.ventas.filter((v) => v.estado == 1).reduce((sum, v) => sum + parseFloat(v.transferencias || 0), 0)
    }
  },
  created() {
    this.ventaService = new VentaService()
    this.sucursalService = new SucursalService()
    this.userService = new UserService()
    this.clienteService = new ClienteService()
    this.auth = useAuth()
    this.medicoService = new MedicoService()
    this.paqueteProductoService = new PaqueteProductoService()
    this.metodoPagoService = new MetodoPagoService()
  },
  mounted() {
    this.cargarSucursales()
    this.cargarUsuarios()
    this.cargarMedicos()
    this.getMetodoPagos()
    this.cargarParametrosSistema()
  },
  methods: {
    cargarParametrosSistema() {
      this.ventaService
        .datos_necesarios_reporte_ventas()
        .then((data) => {
          this.parametros_sistema = data.datos.parametros_sistema ?? []
          if (Array.isArray(this.parametros_sistema)) {
            this.parametros_sistema.forEach((element) => {
              if (element.nombre === 'marcar_entregado') {
                this.marcar_entregado = true
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    validarOcultarColumnas() {
      this.ocultarFacturado = false
      this.ocultarMedico = false
      this.ocultarPaquete = false
      this.ventas.forEach((venta) => {
        if (venta.facturado == 1) this.ocultarFacturado = true
        if (venta.medico_id != null) this.ocultarMedico = true
        if (venta.paquete_id != null) this.ocultarPaquete = true
      })
    },

    textoEstadoEntregado(entregado) {
      if (entregado == 0) return 'NO ENTREGADO'
      else if (entregado == 1) return 'EN PROCESO'
      else if (entregado == 2) return 'ENTREGADO'
      else return '-'
    },

    marcarEntregado(id) {
      this.$confirm.require({
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        message: '¿ESTÁS SEGURO DE MARCAR COMO ENTREGADO?',
        acceptLabel: 'Si, Marcar',
        rejectLabel: 'No, Cancelar',
        acceptClass: 'p-button-primary p-button-lg',
        rejectClass: 'p-button-danger p-button-lg',
        acceptIcon: 'pi pi-save',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.ventaService
            .marcarEntregado(id)
            .then((response) => {
              if (response.success == false) {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: response.message,
                  life: 3000
                })
              } else {
                this.$toast.add({
                  severity: 'success',
                  summary: 'Exito',
                  detail: response.message,
                  life: 3000
                })
                this.BuscarFiltro()
              }
            })
            .catch((error) => console.log(error))
        }
      })
    },

    onPageChange(event) {
      this.paginaActual = event.page + 1
      this.porPagina = event.rows
      this.enviando = true
      this.cargarReporteVentas()
    },

    async expandRow(event) {
      const venta = event.data
      if (!venta.productos) {
        try {
          const response = await this.ventaService.obtenerProductosVenta(venta.id)
          if (response.success) {
            venta.productos = response.productos
          }
        } catch (error) {
          console.error('Error cargando productos:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los productos',
            life: 3000
          })
        }
      }
    },

    getMetodoPagos() {
      this.metodoPagoService.getAllMetodoPagos().then((response) => {
        this.metodo_pagos = response.metodo_pagos || []
        this.metodo_pagos.unshift({ id: 0, nombre: 'TODOS' })
      })
    },

    formatDateTime(dateString) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }
      return new Date(dateString).toLocaleString(undefined, options)
    },

    acciones(data) {
      return [
        {
          label: 'Ver Detalle',
          icon: 'pi pi-fw pi-eye',
          disabled: 'Venta Ver Detalle' in this.auth.user.permissions ? false : true,
          to: `/ventas/${data.id}/detalle`
        },
        {
          label: 'Imprimir',
          icon: 'pi pi-print',
          command: () => {
            this.imprimirVenta(data.id)
          }
        },
        {
          visible: 'Venta Facturar' in this.auth.user.permissions ? true : false,
          label: 'Crear Factura',
          disabled: data.facturado == 1 || data.estado == 0 ? true : false,
          icon: 'pi pi-fw pi-file',
          command: () => this.ventaFacturar(data)
        },
        {
          label: 'Marcar Entregado',
          icon: 'pi pi-fw pi-check',
          disabled: data.entregado == 2 ? true : false,
          visible: this.marcar_entregado,
          command: () => {
            this.marcarEntregado(data.id)
          }
        }
      ]
    },

    ventaFacturar(venta) {
      this.ventaFactura = {
        ...venta,
        nit: venta.nit && venta.nit !== '0' && venta.nit !== '99001' ? Number(venta.nit) : null
      }
      this.ventafacturaDialog = true
    },

    imprimirVenta(id) {
      this.ventaService
        .imprimirVenta(id)
        .then(() => {})
        .catch((error) => console.log(error))
    },

    ocultarDialog() {
      this.ventafacturaDialog = false
    },

    textoEstado(estado) {
      if (estado == 0) return 'ANULADA'
      else if (estado == 1) return 'VALIDA'
      else return 'PENDIENTE'
    },

    textoFacturado(facturado) {
      return facturado == 0 ? 'NO' : 'SI'
    },

    buscarCliente(event) {
      setTimeout(() => {
        this.clienteService
          .buscarXNombre({ texto: event.query })
          .then((response) => {
            this.clientesListadoFiltrado = [...response.clientes]
          })
          .catch((error) => console.log(error))
      }, 250)
    },

    exportVentas() {
      if (this.ventas.length > 0) {
        let datos = {
          sucursal_id: this.sucursalSelected,
          user_id: this.userSeleccionado,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          cliente_id: this.clienteSelected,
          estado: this.estadoSelected,
          codigoVenta: this.codigoVenta,
          medico_id: this.medicoSelected,
          nombre_paquete: this.paqueteSelected,
          codigoCaja: this.codigoCaja
        }
        this.ventaService.exportarVentas(datos).then(() => {
          this.exportando = false
          this.$toast.add({
            severity: 'success',
            summary: 'Exportación exitosa',
            detail: 'Se ha exportado correctamente',
            life: 3000
          })
        })
      } else {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay datos para exportar',
          life: 3000
        })
      }
    },

    generarPDF() {
      if (this.ventas.length > 0) {
        this.generandoPDF = true
        let datos = {
          sucursal: this.sucursalSelected,
          user_id: this.userSeleccionado,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
          estado: this.estadoSelected,
          codigoVenta: this.codigoVenta,
          medico_id: this.medicoSelected,
          nombre_paquete: this.paqueteSelected,
          codigoCaja: this.codigoCaja
        }
        this.ventaService.imprimirPDF(datos).then(() => {
          this.generandoPDF = false
          this.$toast.add({
            severity: 'success',
            summary: 'Exito',
            detail: 'Se genero el PDF correctamente',
            life: 3000
          })
        })
      } else {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay datos para generar el reporte',
          life: 3000
        })
      }
    },

    cargarUsuarios() {
      this.userService.getUsersAll().then((data) => {
        this.users = data || []
        this.users.unshift({ id: 0, name: 'TODOS' })
      })
    },

    cargarMedicos() {
      this.medicoService.getMedicosAll().then((data) => {
        this.medicos = data.medicos || []
        this.medicos.unshift({ id: 0, nombre_completo: 'TODOS' })
      })
    },

    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((data) => {
          data.forEach((sucursal) => {
            this.sucursales.push(sucursal)
          })
        })
        .catch((error) => console.log(error))
    },

    BuscarFiltro() {
      this.ventas = []
      this.paginaActual = 1
      this.enviando = true
      this.cargarReporteVentas()
    },

    cargarReporteVentas() {
      let datos = {
        sucursal: this.sucursalSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        user_id: this.userSeleccionado,
        cliente_id: this.clienteSelected?.id || null,
        estado: this.estadoSelected,
        codigoVenta: this.codigoVenta,
        medico_id: this.medicoSelected,
        codigoCaja: this.codigoCaja,
        metodo_pago: this.metodoPagoSelected ?? 0,
        page: this.paginaActual,
        per_page: this.porPagina
      }

      this.ventaService
        .filtrarVentasOptimizado(datos)
        .then((response) => {
          if (response.success) {
            this.ventas = response.ventas
            this.totalRegistros = response.pagination.total

            this.totalesGenerales = {
              total_venta: parseFloat(response.totales_generales.total_venta || 0),
              total_descuento: parseFloat(response.totales_generales.total_descuento || 0),
              total_efectivo: parseFloat(response.totales_generales.total_efectivo || 0),
              total_transferencia: parseFloat(response.totales_generales.total_transferencia || 0),
              total_credito: parseFloat(response.totales_generales.total_credito || 0)
            }

            this.ventas_a_creditos = this.totalesGenerales.total_credito

            // Validar columnas dinámicas
            this.validarOcultarColumnas()
          }
          this.enviando = false
        })
        .catch((error) => {
          this.enviando = false
          console.error(error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las ventas',
            life: 3000
          })
        })
    },

    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2
      }).format(numero)
    },

    expandAll() {
      this.expandedRows = this.ventas.filter((p) => p.id)
    },

    collapseAll() {
      this.expandedRows = null
    }
  },

  watch: {
    expandedRows(newVal) {
      if (newVal && newVal.length > 0) {
        newVal.forEach((venta) => {
          if (!venta.productos) {
            this.ventaService
              .obtenerProductosVenta(venta.id)
              .then((response) => {
                if (response.success) {
                  venta.productos = response.productos
                }
              })
              .catch((error) => console.error('Error:', error))
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-invalid {
  color: red;
}

.p-fondo {
  background-color: #7bffae;
  padding: 5px;
  border-radius: 10px;
  margin-bottom: 5px;
  border: 1px solid #002236;
}

.style_card {
  border: 1px solid #000000;
  border-bottom: 3px solid #000000;
  padding: 3px;
}

.titulo-new {
  border-bottom: 1px solid #002236;
  font-size: 1.5rem;
  color: #002236;
  font-weight: bold;
}

.clase-breadcrumb {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 500;
}

/* Estados de entrega */
.status-no-entragado {
  padding: 3px 4px;
  border-radius: 2px;
  font-weight: bold;
  color: white;
  background-color: red;
  font-size: 0.8rem;
}

.status-en-proceso {
  padding: 3px 5px;
  border-radius: 2px;
  font-weight: bold;
  color: white;
  background-color: orange;
  font-size: 0.8rem;
}

.status-entregado {
  padding: 3px 5px;
  border-radius: 2px;
  font-weight: bold;
  color: white;
  background-color: green;
  font-size: 0.8rem;
}
</style>
